import React from "react";
import { Card } from "react-bootstrap";
function EditSection({
                         children,
                         title,
                         mt,
                         ml,
                         mb,
                         childrenStyles,
                         style = { },
                         hasButton = false,
                         button = <></>,
                     }) {
    return (
        <>
            {title && (
                <div
                    className={`mb-${mb ? mb : "4"} mt-${mt ? mt : "2"}`}
                    style={style}
                >
                    <Card.Title className="d-inline text-muted font-weight-bold">
                        {title}
                    </Card.Title>
                    <div className="float-right">{hasButton && button}</div>
                </div>
            )}

            <div
                className={`ml-${ml ? ml : "0"} mb-${mb ? mb : "0"}`}
                style={childrenStyles}
            >
                {children}
            </div>
        </>
    );
}
export default EditSection;
